<template>
  <div class="resume">
    <div class="banner"></div>

    <div class="profile">
      <div class="profile-header">
        <div class="profile-header__title">
          <h1>我的投递</h1>
          <div>
            <!-- <label>
              <i class="el-icon-time"></i>
              地址:{{companyDetail.companyAddress}}
            </label> -->
             <label>当前投递数量:{{companyDetail.total}} </label>
          </div>
          <!-- <div> <label>简介：{{companyDetail.intro}} </label></div> -->
        </div>

        <!-- <div class="profile-header__editor-button">
          <router-link to="/resume/edit">
            <el-button plain round icon="el-icon-edit">编辑</el-button>
          </router-link>
        </div> -->
      </div>

      <div class="resumeForm" >
       <ul  class="content-list"  >
          <li
            class="content-item"
            v-for="item in companyDetail.items"
            :key="item.id"
          >
          <router-link :to="`/jobs/${item.id}`">
            <h3 class="title">{{ item.name }}</h3>
            <div class="subTitle">
              <span class="city">{{ item.zsHq.name }}</span
              >&nbsp;| <span class="city">{{ item.zsLevel.name }}</span
              >&nbsp;| <span class="city">{{ item.shipType.name }}</span
              >&nbsp;| <span class="city">{{ item.shipTLevel.name }}</span
              >&nbsp;|
              <span class="city" style="color:red;">{{ item.salary == "0元" ? "面议" : item.salary }}</span>
            </div>
            <p class="desc">{{ item.intro }}</p>
                  <div
                class="subTitle"
                v-for="(tag, index) in item.tag"
                :key="index"
              >
                <span class="city" style="width:30%">{{ tag.name }}</span
                >&nbsp;
              </div>

                         <span>联系人:{{ item.contact }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>Tel:{{ item.contactMobile }}</span>

            <div>
              <span class="job_category">{{ item.created_at }}更新</span>
            </div> 
          </router-link>
          </li>
        </ul>
        <!-- 分页器 -->
        <!-- <div v-show="!loading" class="pagination-wrapper">
          <pagination
            :current-page.sync="currentPage"
            :total="results.count"
          ></pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
    fetchMyDelivery
} from "@/helper/requestWithToken.js";
import { state } from "@/store";
export default {
  name: "job-detail",
  data() {
    return { companyDetail: {} };
  },

  methods: {
   

  },
  created() {
    let loading = this.$loading({ position: { top: 60 } });
    // const { id } = this.$route.params;
    fetchMyDelivery()
      .then(res => {
        console.log(res);
        this.companyDetail = res.data;
        console.log(this.companyDetail.nickname);
        loading.close();
      })
      .catch(loading.close);
  }
};
</script>

<style lang="less" scoped>
.banner {
  // width: 1200px;
  background-image: url("//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/my_resume_banner_1577084307030.jpg");
  background-size: 100% 100%;
  height: 300px;
  background-repeat: no-repeat;
}

.profile {
  width: 900px;
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .content {
    min-height: 500px;
    padding-left: 20px;
    border-left: 1px solid @border-lighter-color;
    margin-left: 300px;
    &-title {
      margin-bottom: 30px;
      margin-left: 20px;
    }

    &-item {
      margin-bottom: 10px;
      padding: 10px 20px;
      cursor: pointer;
      .title {
        margin: 12px 0;
      }
      .subTitle {
        color: @regular-text-color;
      }
      .desc {
        white-space: pre-line;
        font-size: 14px;
        color: @secondary-text-color;
        .text-overflow-visible-line(2);
        text-overflow: clip;
      }
      &:hover {
        border-radius: 3px;
        background: #fff;
        box-shadow: 0 10px 30px 0 rgba(136, 150, 171, 0.15);
      }
    }
    .pagination-wrapper {
      margin-top: 50px;
      text-align: right;
    }
  }
  
  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 280px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
